import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {
  ApexAxisChartSeries,
  ApexChart,
  ChartComponent,
  ApexDataLabels,
  ApexXAxis,
  ApexYAxis,
  ApexPlotOptions
} from "ng-apexcharts";
import {WhiteLabelService} from "../../../../services/white-label.service";

@Component({
  selector: 'app-report-age-chart',
  templateUrl: './report-age-chart.component.html',
  styleUrls: ['./report-age-chart.component.scss']
})
export class ReportAgeChartComponent implements OnInit, OnChanges {

  chartOptions: any;

  @Input() data: any;

  constructor(public whitelabel: WhiteLabelService) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {

    console.log(this.data);

    const categories = [];
    const values = [];

    for(const item of this.data){
      categories.push(item.code);
      values.push((item.weight * 100).toFixed(2));
    }

    console.log(values);

    this.chartOptions = {
      series: [
        {
          name: "My-series",
          data: values
        }
      ],
      chart: {
        type: "bar",
        height: 280,
        toolbar: {
          show: false
        },
      },
      plotOptions: {
        bar: {
          horizontal: false
        }
      },
      fill: {
        colors: [this.whitelabel.currentColor('primary_colour')]
      },
      stroke: {
        lineCap: 'round',
        show: true,
        colors: [this.whitelabel.currentColor('primary_colour')],
        width: 2
      },
      dataLabels: {
        enabled: false
      },
      yaxis: {
        forceNiceScale: false,
        min: 0,
        max: 100,
        labels: {
          formatter: (value: any) => value.toFixed(0) +'%',
        },
      },
      xaxis: {
        categories: categories
      }
    };

  }

}
